import { WidgetModule } from "@shared/widgets/widget.module";
import { FindCarworkshopMapsModule } from "./../../../modules/private/modules/find-carworkshop-maps/find-carworkshop-maps.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RescheduleModalComponent } from "./reschedule-modal.component";
import { TranslateModule } from "@ngx-translate/core";
import { AngularMaterialModule } from "@shared/modules/angular-material/angular-material.module";
import { ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [RescheduleModalComponent],
  imports: [
    CommonModule,
    WidgetModule,
    FindCarworkshopMapsModule,
    ReactiveFormsModule,
    TranslateModule,
    AngularMaterialModule
  ],
  exports: [RescheduleModalComponent],
  providers: []
})
export class RescheduleModalModule {}
